// Płynne przewijanie (Lenis) zsynchronizowane z ScrollTrigger; kotwice na tej samej stronie jadą miękko pod nagłówek.
import Lenis from "lenis";
import {gsap, ScrollTrigger} from "./shared";

export function initSmoothScroll() {
    const lenis = new Lenis({lerp: 0.11, smoothWheel: true});
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);

    const offset = () => -((document.querySelector("[data-cc-header]")?.offsetHeight || 0) + 16);

    document.addEventListener("click", (event) => {
        const link = event.target.closest("a[href*='#']");
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || link.classList.contains("cc-skip-link")) {
            return;
        }
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) {
            return;
        }
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) {
            return;
        }
        event.preventDefault();
        lenis.scrollTo(target, {offset: offset(), duration: 1.3});
        history.pushState(null, "", url.hash);
    });

    // Podgląd zdjęcia (dialog) blokuje przewijanie strony pod spodem.
    document.addEventListener("cc:scroll-lock", (event) => (event.detail ? lenis.stop() : lenis.start()));

    return lenis;
}
